import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { API_BASE_URL } from "../config";

import {
  loginFailure,
  loginRequest,
  loginSuccess,
} from "../store/auth/authSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { setSession } from "../cms/utils/session";

const Login = () => {
  const dispatch = useDispatch();

  // const [username, setUsername] = useState("");
  // const [password, setPassword] = useState("");
  const [data, setData] = useState({
    username: "",
    password: "",
  });
  const { username, password } = data;
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [pageError, setPageError] = useState("");
  const [logo, setLogo] = useState("");
  const [fav, setFav] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [isInactive, setIsInactive] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  useEffect(() => {
    websitelogo();
  }, []);

  const websitelogo = async () => {
    try {
      const logo = await axios.get(API_BASE_URL + "/get-web-company-profile");
      const weblogo = JSON.parse(JSON.stringify(logo.data));
      if (weblogo.status == 200) {
        // console.log(weblogo, "weblogo");
        setLogo(weblogo.data.logo);
        setFav(weblogo.data.favicon_icon);
        setName(weblogo.data.company_name);
        localStorage.setItem("logo_url", weblogo.data.logo);
      }
    } catch (e) {
      return false;
    }
  };

  const validateForm = () => {
    let errors = {};
    if (!username) {
      errors.username = "Please enter your username";
    }
    if (!password) {
      errors.password = "Please enter your password";
    }

    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  const handleSubmit = async (event) => {
    dispatch(loginRequest());
    event.preventDefault();
    // if (!username) {
    //   setUsernameError("Please enter your username");
    // } else {
    //   setUsernameError("");
    // }
    // if (!password) {
    //   setPasswordError("please enter your password");
    // } else {
    //   setPasswordError("");
    // }

    const errors = validateForm();

    if (Object.keys(errors).length === 0) {
      setLoading(true);

      // ── OLD LOGIN (commented out) ──────────────────────────────────────
      // await axios
      //   .post(`${API_BASE_URL}/cms-login`, {
      //     email: username,
      //     password: password,
      //   })
      //   .then(function (response) {
      //     console.log(response.data);
      //     if (response.data.status === 200) {
      //       toast.success("Login Successfully");
      //       localStorage.setItem("cms_token", response.data.token);
      //       localStorage.setItem(
      //         "trade_user_type",
      //         response.data.user_data.user_type
      //       );
      //       localStorage.setItem(
      //         "trade_user_data",
      //         JSON.stringify(response?.data?.user_data)
      //       );
      //       localStorage.setItem(
      //         "trade_user_id",
      //         JSON.stringify(response?.data?.user_data?.id)
      //       );
      //       setLoading(false);
      //       dispatch(loginSuccess(response.data));
      //       navigate("/cms/home");
      //     } else {
      //       setLoading(false);
      //       toast.error(response.data.error);
      //       dispatch(loginFailure("An error occurred"));
      //       setPageError(response.data.error);
      //     }
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //     setLoading(false);
      //     toast.error(error?.response?.data?.error);
      //     dispatch(loginFailure("An error occurred"));
      //     setPageError(error.response.data.result);
      //   });
      // ──────────────────────────────────────────────────────────────────

      // ── NEW LOGIN ──────────────────────────────────────────────────────
      const getFirstAccessibleRoute = (menuAccess = []) => {
        for (const menu of menuAccess) {
          if (menu.menu_link) return menu.menu_link;
          const first = menu.sub_menus?.find((sm) => sm.sub_menu_link);
          if (first) return first.sub_menu_link;
        }
        return "/cms/home";
      };

      await axios
        .post(`${API_BASE_URL}/cms-internal-login`, {
          email: username,
          password: password,
        })
        .then(function (response) {
          if (response.data.status === 200) {
            const { user, menu_access } = response.data;
            if (user.status === 0) {
              setLoading(false);
              setIsInactive(true);
              return;
            }
            toast.success("Login Successfully");
            /* Both tokens, through one helper: the access token expires in
               fifteen minutes and the refresh token is the only thing that can
               replace it, so storing one without the other ends the session at
               the first expiry. */
            setSession(response.data);
            localStorage.setItem("trade_user_type", user.role);
            localStorage.setItem("trade_user_data", JSON.stringify(user));
            localStorage.setItem("trade_user_id", JSON.stringify(user.id));
            // menu_access stored in Redux state via loginSuccess — no localStorage needed
            setLoading(false);
            dispatch(loginSuccess(response.data));
            const postLoginRedirect = sessionStorage.getItem("postLoginRedirect");
            if (postLoginRedirect) {
              sessionStorage.removeItem("postLoginRedirect");
              navigate(postLoginRedirect);
            } else {
              navigate(getFirstAccessibleRoute(menu_access));
            }
          } else {
            setLoading(false);
            toast.error(response.data.message || "Login failed");
            dispatch(loginFailure("An error occurred"));
            setPageError(response.data.message);
          }
        })
        .catch(function (error) {
          setLoading(false);
          toast.error(error?.response?.data?.message || "Login failed");
          dispatch(loginFailure("An error occurred"));
          setPageError(error?.response?.data?.message || "An error occurred");
        });
      // ──────────────────────────────────────────────────────────────────
    } else {
      setErrors(errors);
    }
  };

  if (isInactive) {
    return (
      <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}>
        <div style={{ textAlign: "center", maxWidth: "480px" }}>
          {/* Icon */}
          <div style={{ width: "96px", height: "96px", borderRadius: "50%", background: "rgba(239,68,68,0.15)", border: "2px solid rgba(239,68,68,0.3)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 32px" }}>
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="1.5" />
              <path d="M4.93 4.93l14.14 14.14" stroke="#ef4444" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </div>
          {/* Heading */}
          <h1 style={{ fontSize: "28px", fontWeight: 800, color: "#f8fafc", margin: "0 0 12px" }}>Account Inactive</h1>
          <p style={{ fontSize: "16px", color: "#94a3b8", lineHeight: 1.7, margin: "0 0 8px" }}>
            Your account has been deactivated and you no longer have access to the CMS.
          </p>
          <p style={{ fontSize: "14px", color: "#64748b", margin: "0 0 40px" }}>
            Please contact your system administrator to restore access.
          </p>
          {/* Divider */}
          <div style={{ width: "48px", height: "2px", background: "rgba(239,68,68,0.4)", margin: "0 auto 40px", borderRadius: "2px" }} />
          {/* Back to login */}
          <button
            onClick={() => setIsInactive(false)}
            style={{ padding: "12px 32px", borderRadius: "10px", border: "1px solid rgba(255,255,255,0.15)", background: "rgba(255,255,255,0.08)", color: "#e2e8f0", fontWeight: 600, fontSize: "14px", cursor: "pointer", letterSpacing: "0.3px" }}
          >
            ← Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="account-pages my-5 pt-sm-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card overflow-hidden">
                <div className="bg-primary bg-soft">
                  <div className="row">
                    <div className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue {name}.</p>
                      </div>
                    </div>
                    <div className="col-5 align-self-center ">
                      <img src={`${logo}`} alt="" className="img-fluid px-3" />
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div className="auth-logo">
                    <a href="index.html" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={fav}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </a>

                    <a href="index.html" className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img src={fav} alt="" height="34" />
                        </span>
                      </div>
                    </a>
                  </div>
                  <div className="p-2">
                    <form className="form-horizontal" onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label htmlFor="username" className="form-label">
                          Username
                        </label>
                        <input
                          type="text"
                          className={
                            errors.username
                              ? "form-control is-invalid"
                              : "form-control "
                          }
                          id="username"
                          name="username"
                          placeholder="Enter username"
                          value={username}
                          onChange={(e) => handleChange(e)}
                          autoComplete="off"
                        />
                        {errors.username && (
                          <div className="text-danger">{errors.username}</div>
                        )}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <div style={{ position: "relative" }}>
                          <input
                            type={showPassword ? "text" : "password"}
                            className={
                              errors.password
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            name="password"
                            placeholder="Enter password"
                            aria-label="Password"
                            autoComplete="new-password"
                            value={password}
                            onChange={(e) => handleChange(e)}
                            style={{ paddingRight: "40px" }}
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword((p) => !p)}
                            style={{
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              color: "#6c757d",
                              padding: "0",
                              lineHeight: 1,
                            }}
                          >
                            <i className={showPassword ? "mdi mdi-eye-off-outline" : "mdi mdi-eye-outline"} style={{ fontSize: "18px" }}></i>
                          </button>
                        </div>
                        {errors.password && (
                          <div className="text-danger">{errors.password}</div>
                        )}
                      </div>

                      {/* <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="remember-check"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="remember-check"
                        >
                          Remember me
                        </label>
                      </div> */}

                      <div className="mt-3 d-grid">
                        {pageError && (
                          <div className="alert alert-danger" role="alert">
                            {pageError}
                          </div>
                        )}
                        <button
                          className="btn btn-primary waves-effect waves-light"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Log In"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;



//Old logic
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// import { API_BASE_URL } from "../config";

// import {
//   loginFailure,
//   loginRequest,
//   loginSuccess,
// } from "../store/auth/authSlice";
// import { useDispatch } from "react-redux";
// import { toast } from "react-toastify";

// const Login = () => {
//   const dispatch = useDispatch();

//   // const [username, setUsername] = useState("");
//   // const [password, setPassword] = useState("");
//   const [data, setData] = useState({
//     username: "",
//     password: "",
//   });
//   const { username, password } = data;
//   const [usernameError, setUsernameError] = useState("");
//   const [passwordError, setPasswordError] = useState("");
//   const [pageError, setPageError] = useState("");
//   const [logo, setLogo] = useState("");
//   const [fav, setFav] = useState("");
//   const [name, setName] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const [errors, setErrors] = useState({});

//   useEffect(() => {
//     websitelogo();
//   }, []);

//   const websitelogo = async () => {
//     try {
//       const logo = await axios.get(API_BASE_URL + "/get-web-company-profile");
//       const weblogo = JSON.parse(JSON.stringify(logo.data));
//       if (weblogo.status == 200) {
//         // console.log(weblogo, "weblogo");
//         setLogo(weblogo.data.logo);
//         setFav(weblogo.data.favicon_icon);
//         setName(weblogo.data.company_name);
//         localStorage.setItem("logo_url", weblogo.data.logo);
//       }
//     } catch (e) {
//       return false;
//     }
//   };

//   const validateForm = () => {
//     let errors = {};
//     if (!username) {
//       errors.username = "Please enter your username";
//     }
//     if (!password) {
//       errors.password = "Please enter your password";
//     }

//     return errors;
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//     setErrors((prev) => ({
//       ...prev,
//       [name]: "",
//     }));
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       handleSubmit();
//     }
//   };

//   const handleSubmit = async (event) => {
//     dispatch(loginRequest());
//     event.preventDefault();
//     // if (!username) {
//     //   setUsernameError("Please enter your username");
//     // } else {
//     //   setUsernameError("");
//     // }
//     // if (!password) {
//     //   setPasswordError("please enter your password");
//     // } else {
//     //   setPasswordError("");
//     // }

//     const errors = validateForm();

//     if (Object.keys(errors).length === 0) {
//       setLoading(true);
//       await axios
//         .post(`${API_BASE_URL}/cms-login`, {
//           email: username,
//           password: password,
//         })
//         .then(function (response) {
//           console.log(response.data);
//           if (response.data.status === 200) {
//             toast.success("Login Successfully");
//             localStorage.setItem("cms_token", response.data.token);
//             localStorage.setItem(
//               "trade_user_type",
//               response.data.user_data.user_type
//             );
//             localStorage.setItem(
//               "trade_user_data",
//               JSON.stringify(response?.data?.user_data)
//             );
//             localStorage.setItem(
//               "trade_user_id",
//               JSON.stringify(response?.data?.user_data?.id)
//             );
//             setLoading(false);

//             dispatch(loginSuccess(response.data));
//             navigate("/cms/home");
//           }else {
//             setLoading(false);
//             toast.error(response.data.error);
//             dispatch(loginFailure("An error occurred"));
//             setPageError(response.data.error);
//           }
//         })
//         .catch(function (error) {
//           console.log(error);
//           setLoading(false);
//           toast.error(error?.response?.data?.error);
//           dispatch(loginFailure("An error occurred"));
//           setPageError(error.response.data.result);
//         });
//     } else {
//       setErrors(errors);
//     }
//   };

//   return (
//     <>
//       <div className="account-pages my-5 pt-sm-5">
//         <div className="container">
//           <div className="row justify-content-center">
//             <div className="col-md-8 col-lg-6 col-xl-5">
//               <div className="card overflow-hidden">
//                 <div className="bg-primary bg-soft">
//                   <div className="row">
//                     <div className="col-7">
//                       <div className="text-primary p-4">
//                         <h5 className="text-primary">Welcome Back !</h5>
//                         <p>Sign in to continue {name}.</p>
//                       </div>
//                     </div>
//                     <div className="col-5 align-self-center ">
//                       <img src={`${logo}`} alt="" className="img-fluid px-3" />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="card-body pt-0">
//                   <div className="auth-logo">
//                     <a href="index.html" className="auth-logo-light">
//                       <div className="avatar-md profile-user-wid mb-4">
//                         <span className="avatar-title rounded-circle bg-light">
//                           <img
//                             src={fav}
//                             alt=""
//                             className="rounded-circle"
//                             height="34"
//                           />
//                         </span>
//                       </div>
//                     </a>

//                     <a href="index.html" className="auth-logo-dark">
//                       <div className="avatar-md profile-user-wid mb-4">
//                         <span className="avatar-title rounded-circle bg-light">
//                           <img src={fav} alt="" height="34" />
//                         </span>
//                       </div>
//                     </a>
//                   </div>
//                   <div className="p-2">
//                     <form className="form-horizontal" onSubmit={handleSubmit}>
//                       <div className="mb-3">
//                         <label htmlFor="username" className="form-label">
//                           Username
//                         </label>
//                         <input
//                           type="text"
//                           className={
//                             errors.username
//                               ? "form-control is-invalid"
//                               : "form-control "
//                           }
//                           id="username"
//                           name="username"
//                           placeholder="Enter username"
//                           value={username}
//                           onChange={(e) => handleChange(e)}
//                           autoComplete="off"
//                         />
//                         {errors.username && (
//                           <div className="text-danger">{errors.username}</div>
//                         )}
//                       </div>

//                       <div className="mb-3">
//                         <label className="form-label">Password</label>
//                         <input
//                           type="password"
//                           className={
//                             errors.password
//                               ? "form-control is-invalid"
//                               : "form-control "
//                           }
//                           name="password"
//                           placeholder="Enter password"
//                           aria-label="Password"
//                           aria-describedby="password-addon"
//                           autoComplete="new-password"
//                           value={password}
//                           // onKeyDown={(e)=>handleKeyDown(e)}
//                           onChange={(e) => handleChange(e)}
//                         />
//                         {errors.password && (
//                           <div className="text-danger">{errors.password}</div>
//                         )}

//                         {/* <button
//                           className="btn btn-light "
//                           type="button"
//                           name="password"
//                           id="password-addon"
//                         >
//                           <i className="mdi mdi-eye-outline"></i>
//                         </button> */}
//                       </div>

//                       {/* <div className="form-check">
//                         <input
//                           className="form-check-input"
//                           type="checkbox"
//                           id="remember-check"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="remember-check"
//                         >
//                           Remember me
//                         </label>
//                       </div> */}

//                       <div className="mt-3 d-grid">
//                         {pageError && (
//                           <div className="alert alert-danger" role="alert">
//                             {pageError}
//                           </div>
//                         )}
//                         <button
//                           className="btn btn-primary waves-effect waves-light"
//                           type="submit"
//                           disabled={loading}
//                         >
//                           {loading ? (
//                             <span className="spinner-border spinner-border-sm"></span>
//                           ) : (
//                             "Log In"
//                           )}
//                         </button>
//                       </div>
//                     </form>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Login;
